<ng-container *ngTemplateOutlet="mode() === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('md') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="homefilterdesk"></ng-container>
    }
    }
</ng-template>

<ng-template #homefilterdesk>
    <div class="figma4">
        @if(cruiseregions()?.length > 0) {

        <clever-searchlist [mode]="'home'" [title]="'Reiseziele'" (sendSelection)="setRes('cruiseregion', $event)"
            [list]="cruiseregions()" class="w150px"></clever-searchlist>
        }
        @if(cruiseCompany()?.length > 0) {
        <clever-searchlist [mode]="'home'" [title]="'Reedereien'" (sendSelection)="setRes('cruisecompanys', $event)"
            [list]="cruiseCompany()" [listpriority]="cruiseCompanypriority()" [showVc]="true" class="w150px"></clever-searchlist>
        }
        @if(cruiseschiffe()?.length > 0) {
        <clever-searchlist [mode]="'home'" (sendSelection)="setRes('schiffes', $event)" [title]="'Schiffe'"
            [list]="cruiseschiffe()" class="w150px"></clever-searchlist>
        }
        @if(showDate()) {
        <clever-date [start]="start()" [end]="end()" [mindauer]="mindauer()" [maxdauer]="maxdauer()"
            (selectValue)="selectDateValue($event)" [mode]="'home'" class="w300px">
        </clever-date>
        }
        <clever-traveller [mode]="'home'" [context]="'cruise'" (sendRes)="resTraveler($event)">
        </clever-traveller>
        <button (click)="gotoZiel()" class="custombutton">
            <img src="../../../../assets/tvg/search.svg" alt="search" />
            <span>{{btntext()}}</span>
        </button>
    </div>
</ng-template>

<ng-template #homemodeMobile>
    <div class="tmp-inputs-wrapper-mobile">
        <div class="figma4_mobile">
            @if(cruiseregions()?.length > 0) {
            <clever-searchlist [mode]="'home'" [title]="'Reiseziele'" (sendSelection)="setRes('cruiseregion', $event)"
                [list]="cruiseregions()"></clever-searchlist>
            }
            @if(cruiseCompany()?.length > 0) {
            <clever-searchlist [mode]="'home'" [title]="'Reedereien'" (sendSelection)="setRes('cruisecompanys', $event)"
                [list]="cruiseCompany()" [listpriority]="cruiseCompanypriority()" [showVc]="true"></clever-searchlist>
            }
            @if(cruiseschiffe()?.length > 0) {
            <clever-searchlist [mode]="'home'" (sendSelection)="setRes('schiffes', $event)" [title]="'Schiffe'"
                [list]="cruiseschiffe()"></clever-searchlist>
            }
            @if(showDate()) {
            <clever-date [start]="start()" [end]="end()" [mindauer]="mindauer()" [maxdauer]="maxdauer()"
                (selectValue)="selectDateValue($event)" [mode]="'home'" class="w300px">
            </clever-date>
            }
            <clever-traveller [mode]="'home'" [context]="'cruise'" (sendRes)="resTraveler($event)">
            </clever-traveller>
            <button (click)="gotoZiel()" class="custombutton">
                <img src="../../../../assets/tvg/search.svg" alt="search" />
                <span>{{btntext()}}</span>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #nohomefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="nohomemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="nohomemodeMobile"></ng-container>
    }
    @case ('md') {
    <ng-container *ngTemplateOutlet="nohomemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="nohomefilterdesk"></ng-container>
    }
    }
</ng-template>


<ng-template #nohomemodeMobile>
    @if(smallVersion()) {
    <div class="tmp-inputs-wrapper-nohome-mobile">
        <div class="smallfilter-mobile-wrapper mat-elevation-z1" (click)="showMBMenu()">
            <div class="m05">
                <span class="smallfilter-title">
                    Kreuzfahrten
                </span>
                <div class="smallfilter-body">
                    <span class="smallitem">
                        @if(showDate()) {
                        <clever-date [start]="start()" [end]="end()" [mindauer]="mindauer()" [maxdauer]="maxdauer()"
                            (selectValue)="selectDateValue($event)" [mode]="'nohomesmall'">
                        </clever-date>
                        }
                    </span>
                    <span class="smallitem">
                        <clever-traveller [mode]="'nohomesmall'" [context]="'cruise'"></clever-traveller> P |
                    </span>
                </div>
            </div>
            <button class="smallfilter-btn" (click)="showMBMenu()" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
            </button>
        </div>
    </div>
    } @else {
    <ng-container *ngTemplateOutlet="nohomefilterdesk"></ng-container>
    }
</ng-template>

<ng-template #nohomefilterdesk>
    <div class="tmp-inputs-wrapper-nohome">
        <div class="figma4_mobile">
            <div class="gr-btn-mobile">
                @if(cruiseregions()?.length > 0) {
                <clever-searchlist [mode]="'nohome'" [title]="'Reiseziele'"
                    (sendSelection)="setRes('cruiseregion', $event)" [list]="cruiseregions()"></clever-searchlist>
                }
                @if(cruiseCompany()?.length > 0) {
                <clever-searchlist [mode]="'nohome'" [title]="'Reedereien'"
                    (sendSelection)="setRes('cruisecompanys', $event)" [list]="cruiseCompany()"></clever-searchlist>
                }
            </div>
            @if(cruiseschiffe()?.length > 0) {
            <clever-searchlist [mode]="'nohome'" (sendSelection)="setRes('schiffes', $event)" [title]="'Schiffe'"
                [list]="cruiseschiffe()"></clever-searchlist>
            }
            @if(showDate()) {
            <clever-date [start]="start()" [end]="end()" [mindauer]="mindauer()" [maxdauer]="maxdauer()"
                (selectValue)="selectDateValue($event)" [mode]="'nohome'" class="w300px">
            </clever-date>
            }
            @if(airports()?.length > 0) {
            <clever-searchlist [mode]="'nohome'" (sendSelection)="setRes('airports', $event)" [title]="'Abflughafen'"
                [list]="airports()" class="w100">
            </clever-searchlist>
            }
            <div class="gr-btn-mobile">
                @if(startHafenDatas()?.length > 0) {
                <clever-searchlist [mode]="'nohome'" (sendSelection)="setRes('cruisestarthafen', $event)"
                    [title]="'Starthafen'" [list]="startHafenDatas()" class="w50"></clever-searchlist>
                }
                @if(ziehlHafenDatas()?.length > 0) {
                <clever-searchlist [mode]="'nohome'" (sendSelection)="setRes('cruisezielhafen', $event)"
                    [title]="'Zielhafen'" [list]="ziehlHafenDatas()" [showVc]="true" class="w50">
                </clever-searchlist>
                }
            </div>

            <clever-traveller [mode]="'nohome'" (sendRes)="resTraveler($event)">
            </clever-traveller>
        </div>
        <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
            <mat-icon fontIcon="search"></mat-icon>
            <span>{{btntext()}}</span>
        </button>
    </div>
</ng-template>

<ng-template #moreFilter>
    <!-- <app-cruiseextrafilters [mode]="'home'" class="w100 max1050" (closeModal)="openclosemore()">
    </app-cruiseextrafilters> -->
</ng-template>